import type { GameWithdrawResponse } from '@/features/finance/services/paymentService';

/**
 * POST /game-wallet/withdraw answers 200 `success` both when the money landed in the wallet and when
 * the move is only requested (`data.status: 'pending'`: manual-withdrawal games, amounts at or over
 * the auto-approve threshold, any other move held for review — staff approve it first). Only a landed move
 * may be shown as money in My money.
 */
export function isGameWithdrawLanded(response: GameWithdrawResponse): boolean {
  if (!response.success) return false;
  const status = response.data?.status;
  return status == null || status === 'completed';
}

/** Accepted, but only as a request staff still have to approve (nothing is in the wallet yet). */
export function isGameWithdrawRequested(response: GameWithdrawResponse): boolean {
  return response.success && !isGameWithdrawLanded(response);
}
